export const DEFAULT_USER_DATA = {
  admin: false,
};

export const FONT_SIZE_LINK = "20px";
